import React, { Component } from 'react';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import FocusTrap from 'focus-trap-react';

import modalImgImport from '../../images/background/optimized_modal_img.webp';
import modalImgCarImport from '../../images/background/optimized_modal_img_car.webp';
import { getSessionItem, setLocalItem, setSessionItem } from '../../utils/storage';
import { trackMetaEvent } from '../../utils/metaPixel';

const modalImg = typeof modalImgImport === 'object' ? modalImgImport.default : modalImgImport;
const modalImgCar = typeof modalImgCarImport === 'object' ? modalImgCarImport.default : modalImgCarImport;

let keywordCategories = {};
try { keywordCategories = require('../../data/keyword_categories.json'); } catch (e) { /* optional */ }

const ATTR_STORAGE_KEY =
  process.env.REACT_APP_ATTR_STORAGE_KEY;

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = { phone: '', phoneError: '' };
    this.handleChange = this.handleChange.bind(this);
  }

  isCarPage = () => {
    const path = (this.props.location && this.props.location.pathname) || '';
    const slug = path.replace(/^\//, '');
    if (slug.startsWith('car-') || slug === 'car-ac-repair') return true;
    const meta = keywordCategories[slug];
    return meta && meta.vehicleType === 'car';
  };

  setBodyScrollLock = (locked) => {
    if (typeof document === 'undefined') return;
    if (locked) {
      // Measure scrollbar width BEFORE hiding overflow so the padding-right
      // fallback in .rr-modal-open exactly compensates for the lost scrollbar.
      const scrollbarW = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--scrollbar-width', scrollbarW + 'px');
    }
    document.body.classList.toggle('rr-modal-open', Boolean(locked));
    if (!locked) {
      document.documentElement.style.removeProperty('--scrollbar-width');
    }
  };

  componentDidMount() {
    // Prevent background scroll while modal is open.
    this.setBodyScrollLock(this.props.openModal);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.openModal !== this.props.openModal) {
      this.setBodyScrollLock(this.props.openModal);
    }
  }

  componentWillUnmount() {
    this.setBodyScrollLock(false);
  }

  validatePhone = () => {
    const phoneRegex = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
    const isValidPhone = phoneRegex.test(this.state.phone);
    if (isValidPhone) {
      this.setState({ phoneError: '' });
    } else {
      this.setState({ phoneError: 'Invalid Phone Number' });
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  sendPromotionalSMS = (phone) => {
    const requestData = { phone: phone };
    axios
      .post('https://ridenrepair.com/api/send_promotional_intro_sms', requestData)
      .then((response) => {
        
      })
      .catch((error) => {
        
      });
  };

  getAttributionFromSession = () => {
    if (typeof window === 'undefined') return {};
    try {
      const raw = getSessionItem(ATTR_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : {};
      if (!parsed.gclid) {
        const fallbackGclid = getSessionItem(process.env.REACT_APP_GCLID_SESSION_KEY);
        if (fallbackGclid) {
          parsed.gclid = fallbackGclid;
        }
      }
      return parsed;
    } catch (e) {
      return {};
    }
  };

  storeLeadAttribution = (phone, context = {}) => {
    if (!phone) return;
    const attribution = this.getAttributionFromSession();
    const payload = {
      phone,
      event_type: context.event_type || 'lead',
      lead_source: context.lead_source || null,
      booking_source: context.booking_source || null,
      utm_source: attribution.utm_source || null,
      utm_medium: attribution.utm_medium || null,
      utm_campaign: attribution.utm_campaign || null,
      gclid: attribution.gclid || null,
      fbclid: attribution.fbclid || null,
      landing_url: attribution.landing_url || null,
      referrer: attribution.referrer || null,
      session_id: attribution.session_id || null,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    };

    axios
      .post('https://ridenrepair.com/api/add_lead_attribution', payload)
      .then(() => {})
      .catch(() => {});

    if (attribution.gclid) {
      axios
        .post('https://ridenrepair.com/api/store_gclid', {
          gclid: attribution.gclid,
          phone,
        })
        .then(() => {})
        .catch(() => {});
    }
  };

  checkRider = async () => {
    // /auto/check_rider is auth-gated (returns 401 for public/unauthenticated
    // callers). The public website has no auth, so this call always 401'd and,
    // being awaited in handleSubmit without a guard, aborted the submit before
    // history.push('/booking') — stranding the user (modal closed, lead stored,
    // no navigation). Call disabled; treat every public submitter as a customer
    // so the booking redirect always runs.
    // const response = await axios.get("https://ridenrepair.com/auto/check_rider", {
    //   params: { phone_number: phone },
    // });
    // return response.data.exists;
    return false;
  };

  // handleSubmit = async (event) => {
  //   event.preventDefault();

  //   if (typeof window !== 'undefined') {
  //     window.dataLayer.push({ event: 'SubscribeNow' });
  //   }

  //   const { isMobileApp, isMobileBrowser } = this.props;

  //   let customer_source = '';
  //   if (isMobileApp) {
  //     customer_source = 'app';
  //   } else if (isMobileBrowser) {
  //     customer_source = 'mobile_browser';
  //   } else {
  //     customer_source = 'desktop_browser';
  //   }

  //   const phoneRegex = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
  //   const isValidPhone = phoneRegex.test(this.state.phone);

  //   if (!isValidPhone) {
  //     this.setState({ phoneError: 'Invalid Phone Number' });
  //     return; 
  //   }

  //   this.props.setOpenModal(false);
  //   if (typeof localStorage !== 'undefined') {
  //     localStorage.setItem('phone_provided', 'yes');
  //   }

  //   // Update global user state with whatever number user typed
  //   this.props.setUser({ ph: this.state.phone });

  //   const params = {
  //     phone: this.state.phone,
  //     lead_source: customer_source,
  //   };
  //   this.sendPromotionalSMS(this.state.phone.replace(/\D/g, '').slice(-10));
  //   axios.post("https://ridenrepair.com/api/add_phone_lead", params).then((res) => {
  //     if (res.status === 200) {
  //       this.props.setUser({ ph: this.state.phone });
  //     }
  //   });

  //   this.storeGclidInRedis();

  //   // Dispatch event to trigger chatbot opening
  //   if (typeof window !== 'undefined') {
  //     window.dispatchEvent(
  //       new CustomEvent('rnr:openChat', {
  //         detail: { phone: this.state.phone },
  //       })
  //     );
  //   }
  // };


  handleSubmit = async (event) => {
    event.preventDefault();

    if (typeof window !== 'undefined') {
      window.dataLayer.push({ event: 'SubscribeNow' });
    }

    const { isMobileApp, isMobileBrowser } = this.props;

    // Check for attribution in session storage first
    let customer_source = '';
    const attribution = this.getAttributionFromSession();
    if (attribution.gclid) {
      customer_source = 'google_click_ads';
    } else if (attribution.fbclid) {
      customer_source = 'meta_click_ads';
    } else {
      // Fallback to device-based lead source if no gclid
      if (isMobileApp) {
        customer_source = 'app';
      } else if (isMobileBrowser) {
        customer_source = 'mobile_browser';
      } else {
        customer_source = 'desktop_browser';
      }
    }

    const phoneRegex = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
    const isValidPhone = phoneRegex.test(this.state.phone);

    if (isValidPhone) {
      this.props.setOpenModal(false);
      if (typeof localStorage !== 'undefined') {
        setLocalItem('phone_provided', 'yes');
      }

      const params = {
        phone: this.state.phone,
        lead_source: customer_source,
      };

			trackMetaEvent('PhoneLead');

      this.sendPromotionalSMS(this.state.phone.replace(/\D/g, '').slice(-10));
      axios.post("https://ridenrepair.com/api/add_phone_lead", params).then((res) => {
        if (res.status === 200) {
          this.props.setUser({ ph: this.state.phone });
        } else {
          
        }
      });

      this.props.setUser({ ph: this.state.phone });

      this.storeLeadAttribution(this.state.phone, {
        event_type: 'lead',
        lead_source: customer_source,
      });

      const url =
        'whatsapp://send?phone=917302224253&text=Hi%2C%0A%0AI%20would%20like%20to%20get%20my%20two-wheeler%20serviced%2Frepaired%20from%20Ride%20N%20Repair%21';

      const check_rider = await this.checkRider(this.state.phone);

      if (
        customer_source !== 'desktop_browser' &&
        typeof window !== 'undefined' &&
        !check_rider
      ) {
        window.open(url, '_blank');
      }

      this.props.history.push('/booking');
    } else {
      this.setState({ phoneError: 'Invalid Phone Number' });
    }
  };
  
  render() {
    const { openModal, setOpenModal } = this.props;

    if (!openModal) return null;

    const handleClose = (e) => {
      if (e) e.preventDefault();
      if (typeof sessionStorage !== 'undefined') {
        setSessionItem('phone_ignored', 'yes');
      }
      this.setBodyScrollLock(false);
      setOpenModal(false);
    };

    return (
      <FocusTrap>
        <section role="dialog" aria-modal="true" aria-labelledby="rnrModalHeading">
          <div className="modal-popup" id="modal-popup">
            <div className="modal-popup-inner">
              <div className="modal-popup__photo" style={{ aspectRatio: '1 / 1' }}>
                <img
                  src={this.isCarPage() ? modalImgCar : modalImg}
                  alt="Ride N Repair Mechanic at doorstep"
                  loading="eager"
                  fetchpriority="high"
                  width={420}
                  height={420}
                  style={{ aspectRatio: '1 / 1' }}
                />
              </div>
              <div className="modal-popup__text">
                <h2 className="heading" id="rnrModalHeading">Real-time doorstep repairs</h2>
                <p className="subtitle">Book a certified mechanic in <strong>30&nbsp;seconds</strong>. We come to you—home, office or roadside.</p>
                <p className="rr-modal-trust">Verified mechanic · 30-day warranty · pay only what you approve · we never share your number</p>

                <form onSubmit={this.handleSubmit} className="rr-modal-form">
                  <div className="rr-phone-row">
                    <span className="rr-phone-prefix">+91</span>
                    <input
                      type="tel"
                      inputMode="tel"
                      autoComplete="tel"
                      name="phone"
                      className="form-control rr-phone-input"
                      placeholder="Phone Number"
                      value={this.state.phone}
                      onChange={this.handleChange}
                      required
                      autoFocus={!this.props.isMobileBrowser}
                    />
                  </div>
                  {this.state.phoneError && <p className="rr-modal-error">{this.state.phoneError}</p>}
                  <button type="submit" className="btn btn-primary w-100 radius-xl">
                    Book Now
                  </button>
                  <p className="rr-modal-consent" style={{ fontSize: '11px', lineHeight: 1.35, opacity: 0.65, textAlign: 'center', margin: '8px 0 0' }}>
                    By booking, you accept Ride N Repair Private Limited's <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>.
                  </p>
                </form>
              </div>
              <button
                aria-label="Close modal"
                className="modal-popup__close"
                onClick={handleClose}
              >
                X
              </button>
            </div>
          </div>
        </section>
      </FocusTrap>
    );
  }
}

export default withRouter(Modal);